import { UIElement } from '../../../shared-components/components/ui-element';
import { Component } from '../../../shared-components/decorators/component.decorator';
import styles from './ui-point.css';

/**
 * @class
 * @memberof ChartsComponents
 * @element ui-point
 * @augments {UIElement}
 * @alias UIPoint
 * @classdesc Represents a class for <code>ui-point</code> element.
 * This is a point for series object, tag representations.
 * For more details visit: https://api.highcharts.com/class-reference/Highcharts.Point
 * @property {object} attrs Holds attributes.
 * @property {number|string} y Values of the point.
 * @property {string} name Name of the point.
 * @property {string} icon Icon for the point where supported.
 * @example
 * <ui-point x="12" y="123" z="0" name="boo"></ui-point>
 * point.getAttrs() will produce
 * {
 *   x: 12,
 *   y: 123,
 *   z: 0,
 *   name: "boo"
 * }
 */
@Component({ tag: 'ui-point', styles })
export class UIPoint extends UIElement {
    private attrs: Record<string, string | number | boolean> = {};

    /**
     * If attribute is a number return it as number, otherwise string.
     * @param {string} attr
     * @returns {number | string}
     * @private
     */
    private getAttrAsType(attr: string): number | string {
        return isNaN(Number(attr)) ? attr : Number(attr);
    }

    /**
     * Reflect attributes to properties.
     * Except rendered and state attributes.
     * @private
     */
    private attributesToProperty(): void {
        for (const attr of this.attributes) {
            const name = attr.name;
            const value = this.getAttrAsType(attr.nodeValue ?? '');
            if (name === 'state') {
                continue;
            }
            if (name === 'hidden') {
                this.attrs.visible = false;
            }
            if (name === 'class') {
                this.attrs.className = value;
            } else {
                this.attrs[name] = value;
            }
        }
    }

    /**
     * Gets the attributes as JSON object.
     * @returns {object}
     */
    getAttrs(): Record<string, string | number | boolean> {
        this.attrs = {};
        this.attributesToProperty();
        return this.attrs;
    }
}
